import { Grid } from '@mui/material'
import { GridColDef, DataGrid } from '@mui/x-data-grid'
import { linear_v, linear_item, linear_h } from '../../../libs/linear-layout/LinearLayout'
import Title from '../../../libs/rhf-mui/ui/Title'
import AppMenuButton from '../../components/AppMenuButton'
import { UniFunc } from '../../dao/UniFunc'

type Props = {
  DataList: UniFunc[];
  OnRowSelected: (sel: UniFunc) => void;
}

const DgvUniFunc = ({ DataList, OnRowSelected }: Props) => {
  return (
    <Grid {...linear_v} >
      <Grid {...linear_item}  >
        {render_dgvUniFunc_ActionBar()}
      </Grid>
      <Grid {...linear_item} flex={1} >
        {render_dgvUniFunc_DataGrid()}
      </Grid>
    </Grid>
  )

  function render_dgvUniFunc_ActionBar() {
    return (<Grid  {...linear_h} alignItems='center' p={1}>
      <AppMenuButton label={<Title variant='subtitle2'>問卷功能列表</Title>} />
      <Grid {...linear_item} flex={1}>
        {/* blank full width */}
      </Grid>
      <Grid {...linear_item}>
        <Title>...</Title>
      </Grid>
    </Grid>);
  }

  function render_dgvUniFunc_DataGrid() {

    const uni_func_columns: GridColDef[] = [
      { field: 'serno', headerName: 'serno', width: 85, editable: true },
      { field: 'guid', headerName: 'guid', width: 150, editable: true },
      { field: 'func_code', headerName: '功能代碼', width: 120 },
      { field: 'func_short', headerName: '問卷功能名稱', flex: 1 },
    ];

    return (
      <DataGrid style={{ width: '100%', backgroundColor: 'white', padding: '12px' }}
        getRowId={(data) => { return data.guid }}
        rows={DataList}
        columns={uni_func_columns}

        pageSize={100} rowsPerPageOptions={[100]} hideFooterSelectedRowCount

        onRowClick={(params) => {
          const sel_data = (params.row as UniFunc);
          OnRowSelected(sel_data);
        }}
      />
    );
  }

}

export default DgvUniFunc